import { Fragment, useContext } from 'react';
import TrophyContext from '../../context/trophys/trophysContext';

const ServerError = () => {
  const trophysContext = useContext(TrophyContext);

  return (
    <Fragment>
      {trophysContext.serverError && (
        <div className={`alert alert-${trophysContext.serverError.type}`}>
          <i className="fa-solid fa-exclamation-circle me-2" />
          {trophysContext.serverError.msg}
        </div>
      )}
    </Fragment>
  );
};

export default ServerError;
